.sidebar,
.additional-entries {
  display: flex;
  flex-flow: column nowrap;

  gap: var(--mantine-spacing-xs);
  align-items: center;
}

.sidebar {
  z-index: 100;
  grid-area: sidebar;
  width: calc(4rem * var(--mantine-scale));
  padding: var(--mantine-spacing-xs);
  overflow: hidden auto;
  background: alpha(light-dark(var(--mantine-color-dark-7), var(--mantine-color-dark-4), 0.2));
  box-shadow:
    1px 0 1.2rem #00000010,
    1px 0 calc(var(--mantine-spacing-md) * 0.4) #00000010;
  backdrop-filter: blur(var(--mantine-spacing-xl));
}

.logo {
  position: relative;
  margin-block-end: var(--mantine-spacing-md);
  text-decoration: none;
  &::after {
    position: absolute;
    inset: -0.4rem;
    z-index: -1;
    pointer-events: none;
    content: '';
    border-radius: var(--mantine-radius-sm);
    transition: background 0.1s ease-out;
  }
  &:hover {
    &::after {
      background: alpha(var(--mantine-color-dark-3), 0.3);
    }
  }
  svg {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.additional-entries {
  margin-top: auto;
}

.portal {
  display: contents;
}

.entry-error {
  pointer-events: none;
  opacity: 0.5;
}

.entry-loading {
  pointer-events: none;
  opacity: 0.5;
}
